import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=719959b5&scoped=true&"
import script from "./AddClients.vue?vue&type=script&lang=js&"
export * from "./AddClients.vue?vue&type=script&lang=js&"
import style0 from "./AddClients.vue?vue&type=style&index=0&id=719959b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719959b5",
  null
  
)

export default component.exports